var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","clipped-left":"","color":"primary","dark":""}},[_c('div',{staticClass:"d-flex align-center"},[(_vm.isEnterMode)?[_c('div',{staticClass:"headline"},[_vm._v("Аккредитация. Ввод заявок")])]:[_c('div',{staticClass:"headline"},[_vm._v("Аккредитация. Поиск заявок")])]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }